import Card from '../components/Card';

function Introduction() {
  return (
    <div className="App">

      <div className="vertical-content">
        <div className="vertical-content">
          <div className='top-buffer'>
            <h2>HERRAMIENTA DE CONSULTA DE CONTENIDOS</h2>
          </div>
          <div>
            <h3>NOM-005-SEDATU-2024</h3>
          </div>

          <div className='benefits-title'>
            <span><b>ACERCA DE LA NORMA</b></span>
          </div>

          <div style={{ width: '40%' }}>
            <hr className="red" style={{ margin: '10px 0 10px' }}></hr>
          </div>
          <div className="text-paragraph text-small">
            La NOM-005-SEDATU-2024 fue emitida con el objetivo de establecer el criterio oficial para
            los contenidos que deben desarrollar los municipios en sus respectivos Planes o Programas
            Municipales de Ordenamiento Territorial y/o Desarrollo Urbano (PMOTDU).
          </div>
          
          <div className="text-paragraph text-small">
            Esta regulación establece una batería de contenidos base para el desarrollo de los
            PMOTDU y elimina la discrecionalidad en la determinación de contenidos entre municipios,
            reduciendo las diferencias de estructura y alcances en una comparativa a nivel nacional.
          </div>
          
          <div className="text-paragraph text-small">
            Si bien la norma establece como sujeto obligado a los municipios de México, servirá como
            referencia a todas aquellas personas que estudian o realizan trabajos relacionados con
            el Ordenamiento Territorio, el Desarrollo Urbano y Metropolitano, así como la Gestión
            Urbana.
          </div>
          
          <img className="full-width" src="imgs/intro/welcome/cover.png"
              style={{"marginTop": "-20%"}} alt="Welcome"/>
        </div>

        <div className='vertical-content benefits-container'>
          <div className='horizontal-content benefits-title'>
            <span><b>BENEFICIOS DE LA NOM</b></span>
          </div>
          <div style={{ width: '90%' }}>
          <hr className="red" style={{ margin: '10px 0 10px' }}></hr>
          </div>
          
          <div className='horizontal-content top-content cards-container'>
            <Card text='Ofrece flexibilidad y es adaptable a todos los territorios y su diversidad.'
            image='benefit1' key='benefitCard1'></Card>
            <Card text='Brinda una base armonizada de contenidos para realizar evaluaciones comparativas, que coadyuven al fortalecimiento institucional y la gestión del territorio.'
            image='benefit2' key='benefitCard2'></Card>
            <Card text='Sienta las bases para el desarrollo de instrumentos de planeación que pueden ser perfeccionados en el futuro.'
            image='benefit3' key='benefitCard3'></Card>
            <Card text='Es una oportunidad de generar instrumentos integrales y homologados en su estructura, pero diversos en sus contenidos y alcances.'
            image='benefit4' key='benefitCard4'></Card>
          </div>
        </div>

        <div className='purpose-container full-width'>
          <div className='purpose-content'>
            <div className='full-width purpose-title'>
              <span><b>¿PARA QUÉ SIRVE LA HERRAMIENTA?</b></span>
            </div>
            <div className='purpose-text-paragraph text-small'>
              Para optimizar la consulta de los contenidos aplicables a cada municipio, se
              desarrolló esta herramienta digital, la cual muestra automáticamente los
              contenidos necesarios para la elaboración de planes o programas municipales de
              ordenamiento territorial y/o desarrollo urbano, según el municipio seleccionado.
            </div>
            
            <div className='purpose-text-paragraph text-small'>
              El uso de esta herramienta es sencillo: primero, selecciona la Entidad Federativa
              y luego el Municipio de interés. Posteriormente, indica cuáles herramientas de
              contexto aplican: fronterizo, metropolitano, costero y/o indígena o afromexicano.
              Con esta información, se generará automáticamente un listado con los contenidos
              que el municipio debe desarrollar, acorde a las características seleccionadas.
            </div>

            <div className='full-width purpose-footer'>
              <span><b>Desliza hacia abajo para comenzar a usar la herramienta.</b></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Introduction;
